/**
 * Artist pieces paid straight to the artist (api/artist-orders.js,
 * docs/artist-direct-payment-plan.md).
 */

const FALLBACK_ERROR = 'No se pudo registrar tu pedido. Intenta de nuevo.';

const readJson = async (response, fallbackMessage) => {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) throw new Error(fallbackMessage);
  const data = await response.json();
  if (!response.ok || data?.success === false) throw new Error(data?.error || fallbackMessage);
  return data.data;
};

/**
 * For each Products id: { id, directPay, paymentLink, paymentLinkProvider,
 * acceptsBankTransfer, artistId, artistName }. The server decides — the cart
 * carries no payment flags.
 */
export const fetchDirectPayOptions = async (productIds) => {
  const ids = [...new Set(productIds.filter(Boolean))];
  if (ids.length === 0) return [];
  const response = await fetch(`/api/artist-orders?ids=${encodeURIComponent(ids.join(','))}`);
  const data = await readJson(response, 'No se pudieron consultar los métodos de pago.');
  return data?.options || [];
};

export const createArtistOrder = async (body) => {
  const response = await fetch('/api/artist-orders', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return readJson(response, FALLBACK_ERROR);
};

/**
 * Payment methods every line of an all-direct-pay bag supports. Links aren't
 * offered on kiosks, nor for pre-orders (the 50% deposit isn't the link's
 * amount).
 */
export const artistPaymentOptions = (items, optionsById, { isKiosk = false } = {}) => {
  if (items.length === 0) return [];
  const opts = items.map((item) => optionsById[item.id]);
  if (opts.some((o) => !o?.directPay)) return [];
  return [
    !isKiosk && opts.every((o) => o.paymentLink) && items.every((item) => !item.isPreorder) && 'payment_link',
    opts.every((o) => o.acceptsBankTransfer) && 'bank_transfer',
  ].filter(Boolean);
};

/** 'payment_link' | 'bank_transfer' for an artist direct-pay order, else null. */
export const artistOrderPaymentMethod = (paymentIntentId) => {
  const id = String(paymentIntentId || '');
  if (id.startsWith('artistlink_')) return 'payment_link';
  if (id.startsWith('artisttransfer_')) return 'bank_transfer';
  return null;
};
